import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { StatusBoardContainer, DataTableContainer, EditBox, GeneralInformationContainer } from './StatusComponentBoard.css.js';
import StatusBoard from './StatusBoard';
import ColumnSetPopup from './ColumnSetPopup';
import columnData from './columnData';
import { mainSettingThemeUpdate } from 'redux/action/mainSetting1.js';

const StatusComponentBoard = (props) => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [boardData, setBoardData] = useState(null);
  const theme = useSelector((state) => state.mainSetting1.board.theme);
  const columnSetting = useSelector((state) => state.mainSetting1.board.columns);
  const gasCnt = useSelector((state) => state.mainSetting1.board.length);
  const gasLog = useSelector((store) => store.gasLog);
  const noneModuleTerm = useSelector((store) => store.settings).setting.noneModuleTerm;
  const userIdx = useSelector((store) => store.loginManager.status.userIdx);
  const { flag_ch4_hc } = props.settings.setting;
  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (gasLog.status === 'SUCCESS') {
      const dangerStatusModuleIndex = gasLog.gas.findIndex((gas) => gas.status === 'danger' || gas.status === 'warning');

      if (dangerStatusModuleIndex === -1) {
        dispatch({ type: 'ALERT_OFF' });
      }

      const filteredList = gasLog.gas.filter((x) => x.status !== 'none')

      setBoardData(filteredList);
    }
  }, [noneModuleTerm, gasLog]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!boardData) {
    return <StatusBoardContainer></StatusBoardContainer>;
  }

  return (
    <StatusBoardContainer theme={theme}>
      <DataTableContainer theme={theme} dataLength={boardData.dataLength}>
        <EditBox>
          <select
            onChange={({ target }) => {
              dispatch(mainSettingThemeUpdate(userIdx));
            }}
            defaultValue={theme}
          >
            <option value="normal">기본형</option>
            <option value="excel">엑셀형</option>
          </select>
          <ColumnSetPopup />
        </EditBox>
        <div className="table-box">
          <table>
            <colgroup>
              {columnSetting.map((column, index) => {
                return <col key={index} width={columnData(0)[column]?.colWidth || '150px'} />;
              })}
            </colgroup>
            <thead>
              <tr>
                {columnSetting.map((column, index) => {
                  if (column === 'areaNo' || (column === 'areaNm' && columnSetting.indexOf('areaNo') === -1)) {
                    return <th key={index} rowSpan={5} colSpan={4}>위치</th>;
                  } else if (column === 'areaNm' && columnSetting.indexOf('areaNo') !== -1) {
                    return null;
                  }
                  else if (['shipNo','locationNm'].includes(column)){
                    return null;
                  }

                  // return columnData(0, props.settings.setting.flag_ch4_hc)[column].th;

                  const thElement = columnData(0, flag_ch4_hc)[column].th;
                  return React.cloneElement(thElement, { key: index });
                })}
              </tr>
              <tr style={{backgroundColor: '#ececec', color: 'black', fontSize: '15px', fontWeight: 'bold', border: '#000 1px solid'}}>
                {/* {columnSetting.indexOf('areaNo') !== -1 && columnData(0)['areaNo'].th}
                {columnSetting.indexOf('areaNm') !== -1 && columnData(0)['areaNm'].th}
                {columnSetting.indexOf('shipNo') !== -1 && columnData(0)['shipNo'].th}
                {columnSetting.indexOf('locationNm') !== -1 && columnData(0)['locationNm'].th} */}
              </tr>
              <tr style={{backgroundColor: '#ececec', color: 'black', fontSize: '15px', fontWeight: 'bold', border: '#000 1px solid'}}>
                <td style={{border:'#000 1px solid'}}>18~23.5%</td>
                <td style={{border:'#000 1px solid'}}>10ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>30 ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>10% 미만</td>
                <td style={{border:'#000 1px solid'}}>1.5% 미만</td>
              </tr>
              <tr style={{backgroundColor: '#ececec', color: 'black', fontSize: '15px', fontWeight: 'bold', border: '#000 1px solid'}}>
                <td style={{border:'#000 1px solid'}}>TWA</td>
                <td style={{border:'#000 1px solid'}}>10ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>30 ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>-</td>
                <td style={{border:'#000 1px solid'}}>0.5% 미만</td>
                <td style={{border:'#000 1px solid'}}>180ppm 미만</td>
                <td style={{border:'#000 1px solid'}}>25ppm 미만</td>
              </tr>
              <tr style={{backgroundColor: '#ececec', color: 'black', fontSize: '15px', fontWeight: 'bold', border: '#000 1px solid'}}>
                <td style={{border:'#000 1px solid'}}>STEL</td>
                <td style={{border:'#000 1px solid'}}>15ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>200ppm<br/>미만</td>
                <td style={{border:'#000 1px solid'}}>-</td>
                <td style={{border:'#000 1px solid'}}>3.0% 미만</td>
                <td style={{border:'#000 1px solid'}}>200ppm 미만</td>
                <td style={{border:'#000 1px solid'}}>35ppm 미만</td>
              </tr>
            </thead>
            <tbody>
              {boardData.map((data, i) => {
                return <StatusBoard key={`${data.title}_${data.moduleIdx}`} index={i} flag={props.settings.setting.flag_ch4_hc} gasCnt={gasCnt} {...data} />;
              })}
            </tbody>
          </table>
        </div>
      </DataTableContainer>
      <GeneralInformationContainer theme={theme}>
        <div className="information-title">
          <div className="module-count">운용 중 감지기 대수</div>
          <div className="status">상태종합</div>
        </div>
        <div className="information-data">
          <div className="module-count">{boardData.length} 대</div>
          <div className="status blue">정상 : {boardData.length > 0 && boardData.filter((x) => x.status === 'blue').length} 대</div>
          <div className="status danger">위험 : {boardData.length > 0 && boardData.filter((x) => x.status === 'danger').length} 대</div>
          <div className="status warning">경고 : {boardData.length > 0 && boardData.filter((x) => x.status === 'warning').length} 대</div>
          <div className="status none">미수신 : {boardData.length > 0 && boardData.filter((x) => x.status === 'none').length} 대</div>
        </div>
      </GeneralInformationContainer>
    </StatusBoardContainer>
  );
};

export default StatusComponentBoard;
